import { createAtomObserver } from '@exodus/atoms';
const createExchangePlugin = (params) => {
    const { exchangeModule, exchangeProviders, exchangeAvailability, exchangeQuotesAtom, exchangeStatusAtom, exchangeAvailabilityAtom, exchangeableAssetsAtom, port, } = params;
    const atomObservers = [
        createAtomObserver({ atom: exchangeQuotesAtom, port, event: 'exchangeQuotes' }),
        createAtomObserver({ atom: exchangeStatusAtom, port, event: 'exchangeStatus' }),
        createAtomObserver({ atom: exchangeAvailabilityAtom, port, event: 'exchangeAvailability' }),
        createAtomObserver({ atom: exchangeableAssetsAtom, port, event: 'exchangeableAssets' }),
    ];
    atomObservers.forEach((atomObserver) => atomObserver.register());
    const onLoad = () => {
        exchangeModule.load();
        exchangeProviders.load();
        exchangeAvailability.load();
        atomObservers.forEach((atomObserver) => atomObserver.start());
    };
    const onStop = () => {
        exchangeModule.stop();
        exchangeProviders.stop();
        exchangeAvailability.stop();
        atomObservers.forEach((atomObserver) => atomObserver.unregister());
    };
    return { onLoad, onStop };
};
const exchangePluginDefinition = {
    id: 'exchangePlugin',
    type: 'plugin',
    factory: createExchangePlugin,
    dependencies: [
        'exchangeModule',
        'exchangeProviders',
        'exchangeAvailability',
        'exchangeQuotesAtom',
        'exchangeStatusAtom',
        'exchangeAvailabilityAtom',
        'exchangeableAssetsAtom',
        'port',
    ],
    public: true,
};
export default exchangePluginDefinition;
